const styles = (theme) => ({
    popupIndicatorOpen: {},
});

export default styles;
